<template>
    <rkm-tabs>
        <rkm-tab
            v-for="(aba, index) in localAbas"
            :key="index"
        >
            <template #title>
                <div class="d-flex justify-content-between">
                    <rkm-form
                        v-if="aba.editing"
                        :ref="`TabForm-${index}`"
                    >
                        <rkm-input-group>
                            <rkm-form-input
                                :validations="{required: true, max: maxTitleLength}"
                                class="m-0"
                                name="Nome da aba"
                                small
                                v-model="aba.editingTitle"
                            />

                            <rkm-input-group-append>
                                <rkm-button
                                    @click="$refs[`TabForm-${index}`][0].validate(() => saveTabTitle(aba))"
                                    color="success"
                                    small
                                    title="Salvar"
                                >
                                    <rkm-icon icon="check" />
                                </rkm-button>

                                <rkm-button
                                    v-if="aba.title"
                                    @click="discardTabTitle(aba)"
                                    class="ml-0"
                                    outline
                                    small
                                    title="Descartar"
                                >
                                    <rkm-icon icon="times" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-input-group>
                    </rkm-form>

                    <div v-else>
                        <span>
                            {{ aba.title }}
                        </span>

                        <span
                            @click="editTabTitle(aba)"
                            class="icon-edit ml-1"
                            title="Editar"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="pen" />
                        </span>
                    </div>

                    <div
                        v-if="(allowRemoveAll || abas.length > 1) && (!aba.editing || (aba.editing && !aba.title))"
                        class="d-flex flex-column justify-content-center ml-1"
                    >
                        <span
                            @click="removeTab(aba)"
                            class="icon-remove"
                            title="Excluir"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="times" />
                        </span>
                    </div>
                </div>
            </template>

            <slot
                :aba="aba"
                :index="index"
                name="tab-content"
            />
        </rkm-tab>

        <template #tabs-end>
            <div class="d-flex flex-column justify-content-center ml-1">
                <rkm-button
                    @click="addTab"
                    color="primary"
                    small
                    title="Adicionar aba"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </div>
        </template>
    </rkm-tabs>
</template>

<script>
// Mixins.
import {notification, object} from '@/mixins'

export default {
    computed: {
        localAbas() {
            return this.abas.map(aba => {
                if (!('title' in aba)) {
                    this.$set(aba, 'title', '')
                }

                if (!('editingTitle' in aba)) {
                    this.$set(aba, 'editingTitle', '')
                }

                if (!('editing' in aba)) {
                    this.$set(aba, 'editing', '')
                }

                return aba
            })
        },
    },
    methods: {
        addTab() {
            this.abas.push({...this.clone(this.initialData), title: '', editingTitle: '', editing: true})
        },
        removeTab(aba) {
            const remove = async () => this.abas.splice(this.abas.indexOf(aba), 1)

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir a aba<strong>${aba.title ? ` ${aba.title}` : ''}</strong>?`, remove)
        },
        editTabTitle(aba) {
            aba.editingTitle = aba.title
            aba.editing = true
        },
        saveTabTitle(aba) {
            aba.title = aba.editingTitle
            aba.editingTitle = ''
            aba.editing = false
        },
        discardTabTitle(aba) {
            aba.editingTitle = ''
            aba.editing = false
        },
    },
    mixins: [notification, object],
    props: {
        abas: {type: Array, required: true},
        allowRemoveAll: {type: Boolean, default: false},
        initialData: {type: Object, default: () => ({})},
        maxTitleLength: {type: Number, default: 30},
    },
}
</script>

<style scoped>
.icon-edit {
    color: var(--info);
}
.icon-remove {
    color: var(--danger);
}
</style>